import { Component, computed, input } from '@angular/core';

type CardVariant = 'ghost' | 'flat' | 'keyword' | 'eyebrow-icon';

@Component({
  selector: 'app-public-info-card',
  standalone: false,
  template: `
    <div [class]="cardClass()">
      <div [class]="headerClass()">
        @if (variant() === 'eyebrow-icon') {
          <div class="inline-flex items-center justify-center rounded-full bg-yellow-300 px-2.5 py-2">
            <i [class]="'far fa-' + icon() + ' text-base text-secondary-900'"></i>
          </div>
        } @else {
          <i [class]="'far fa-' + icon() + ' text-2xl text-gray-300'"></i>
        }
        @if (badge()) {
          <span class="inline-block rounded-full bg-yellow-300 px-2 font-bold text-xs text-secondary-900">{{ badge() }}</span>
        }
      </div>
      <div class="mt-4 min-h-[3.2rem] text-lg font-semibold text-gray-800 text-pretty leading-snug">
        <ng-content select="[title]"></ng-content>
      </div>
      <p class="mt-4 sm:mt-6 text-sm text-gray-400">
        <ng-content select="[description]"></ng-content>
      </p>
      <div class="mt-6">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  `,
})
export class PublicInfoCardComponent {
  icon = input.required<string>();
  badge = input<string>();
  variant = input<CardVariant>('ghost');

  cardClass = computed(() => {
    const base = 'flex h-full flex-col rounded-2xl px-8 sm:px-6 pt-6 pb-6';
    switch (this.variant()) {
      case 'flat':        return `${base} bg-gray-50 ring-1 ring-gray-200`;
      case 'keyword':     return `${base} bg-gray-50 ring-1 ring-gray-100`;
      case 'eyebrow-icon':return `${base} bg-gray-50 ring-1 ring-gray-100`;
      default:            return 'flex h-full flex-col px-6 sm:px-0 pt-2 pb-6';
    }
  });

  headerClass = computed(() =>
    this.variant() === 'ghost' || this.variant() === 'flat'
      ? 'flex items-center justify-between'
      : 'flex items-start justify-between'
  );
}
